import { render } from "./AbilityView.vue?vue&type=template&id=99f29184&scoped=true"
import script from "./AbilityView.vue?vue&type=script&lang=js"
export * from "./AbilityView.vue?vue&type=script&lang=js"

import "./AbilityView.vue?vue&type=style&index=0&id=99f29184&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f29184"]])

export default __exports__